import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Indicateur } from 'src/app/shared/models/indicateurs';
import { ParameterService } from 'src/app/shared/service/params/param';
import { IndicateurServiceService } from '../indicateur-objectif/indicateur-objectif.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Constant } from 'src/app/shared/service/utils/contant';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-add-indicateur-objectif',
  standalone: false,
  templateUrl: './add-indicateur-objectif.component.html',
  styleUrl: './add-indicateur-objectif.component.scss'
})


export class AddIndicateurObjectifComponent {

  item: Indicateur= new Indicateur()
  projetData:any=[];
  typeIndicateurData:any=[];
  objectifItems:any=[];
  constructor(
    private modalService: NgbModal,
    private paramService:ParameterService,
    private FecthDataService:FecthDataService,
    private messageService :MessageService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(){
    this.fetchDataProjet();
    //this.getIndicateurProjet();
  }

  close(){
    this.modalService.dismissAll();
  }

  //ajout dindicateur
  addIndicateur(){
    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });
    }
    if (this.item.canSave()) {
      this.ngxService.start();
      this.paramService.addIndicateursObjectif(this.item).subscribe(
        (response:any)=>{
          ////console.log("la reponse du webservice",response);
  
          this.modalService.dismissAll();
          this.FecthDataService.notifySeriviceCreated();
          this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message});
          this.ngxService.stop();
        },
        (error:any)=>{
          ////console.log("une erreur est survenu",error);
        //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.error.message || "Une erreur est survenue. Veuillez réessaye" });
          this.ngxService.stop();
        }
      )
    }
  }//end addIndicateur

  //recup projet
  fetchDataProjet() {
    this.paramService.fetchDataProgramme().subscribe(
      (response:any)=>{
        this.projetData = response.data;
        ////console.log("this.projetData",this.projetData);
      },
      (error)=>{
        ////console.log("une erreur est survenu",error);
      }
    ) ;
  }//end fetchDataProjet

  //recup indicateur
  getIndicateurProjet() {
    this.paramService.fetchTypeIndicateur().subscribe(
      (response:any)=>{
        this.typeIndicateurData = response.data;
        ////console.log("this.projetData",this.typeIndicateurData);
      },
      (error)=>{
        ////console.log("une erreur est survenu",error);
      }
    ) ;
  }//end getIndicateurProjet


     getObjectifSpecifiqueParProgramme(item:any){
    this.paramService.getObjectifSpecifiqueParProgramme(item).subscribe(
      (response:any)=> {
        //console.log("la réponse du webservice",response);
        this.objectifItems = response.data;
            this.getIndicateurProjet();

      },
      (error:any)=>{
        //console.log("une erreur est survenu",error);
        
      }
    )
  }
}